import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-cbb-select',
  templateUrl: './cbb-select.component.html',
  styleUrls: ['./cbb-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CbbSelectComponent),
      multi: true,
    },
  ],
})
export class CbbSelectComponent implements ControlValueAccessor {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() label = '';
  @Input() options: unknown[] = [];
  @Input() bindLabel = '';
  @Input() bindValue?: string;
  @Input() placeholder = 'Seleccionar';
  @Input() clearable = true;
  @Input() searchable = true;
  private _multiple = false;

  @Input()
  set multiple(value: boolean) {
    this._multiple = value;
    this.value = this.normalizeValue(this.value);
    this.cdr.markForCheck();
  }

  get multiple(): boolean {
    return this._multiple;
  }
  @Input() closeOnSelect = true;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() notFoundText = 'No se encontraron resultados';
  @Input() appendTo = 'body';
  /** Texto bajo el control (validación); vacío oculta el mensaje. */
  @Input() mensajeError = '';

  @Output() optionSelected = new EventEmitter<unknown>();

  value: unknown = null;
  isDisabled = false;

  private onChange: (v: unknown) => void = () => {};
  private onTouched: () => void = () => {};

  onModelChange(val: unknown): void {
    const value = this.normalizeValue(val);
    this.value = value;
    this.onChange(value);
    this.onTouched();
    this.optionSelected.emit(value);
    this.cdr.markForCheck();
  }

  get normalizedBindValue(): string | undefined {
    return this.bindValue?.trim() ? this.bindValue : undefined;
  }

  onBlur(): void {
    this.onTouched();
  }

  writeValue(val: unknown): void {
    this.value = this.normalizeValue(val);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (v: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.isDisabled = disabled;
    this.cdr.markForCheck();
  }

  private normalizeValue(value: unknown): unknown {
    return this.multiple && !Array.isArray(value) ? [] : value;
  }
}
